import { InsignProcedureModel } from './insign.model';

export class InsignListResponseModel {
  data: InsignProcedureModel[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}
